import DataTable from '../../../../../components/DataTable/DataTable';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { FormattedDate, FormattedMessage, FormattedNumber, FormattedTime } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { getOpenedTransactions } from '../../../../../store/actions/dashboard/openedTransactions';
import { LOADING } from '../../../../../enums/states';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import socketContext from '../../../../../context/SocketContext';

const openedTransactionsTableColumns = [
  {
    id: 'createdOn',
    label: <FormattedMessage id={'transaction.createdOn'}/>,
    align: 'left',
  },
  {
    id: 'createdBy',
    label: <FormattedMessage id={'transaction.createdBy'}/>,
    align: 'left',
  },
  {
    id: 'note',
    label: <FormattedMessage id={'transaction.note'}/>,
    align: 'left',
  },
  {
    id: 'itemCount',
    label: <FormattedMessage id={'transaction.itemCount'}/>,
    align: 'right',
  },
  {
    id: 'amount',
    label: <FormattedMessage id={'transaction.total'}/>,
    align: 'right',
  },
  {
    id: 'action',
    label: '',
    align: 'right',
  },
];

const OpenedTransactions = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [openedTransaction, setOpenedTransaction] = useState();
  const openedTransactionsRedux = useSelector((state) => state?.dashboard?.openedTransactions);
  let { path } = useRouteMatch();

  const socket = useContext(socketContext);


  useEffect(() => {
    if (openedTransactionsRedux?.data) {
      setOpenedTransaction(
        openedTransactionsRedux.data.map((line) => {
          return {
            ID: line.ID,
            createdOn: (
              <>
                <FormattedDate value={line.created_on}/> <FormattedTime value={line.created_on}/>
              </>
            ),
            createdBy: line.name,
            amount: <FormattedNumber value={line.totalAmount} minimumFractionDigits={2}/>,
            itemCount: <FormattedNumber value={line.lineCount}/>,
            note: line.note,
            action: <><ArrowForwardIcon/></>
          };
        }),
      );
    }
  }, [openedTransactionsRedux, openedTransactionsRedux?.data]);

  useEffect(() => {
    dispatch(getOpenedTransactions());
  }, [dispatch]);

  const refreshOpenedTransactions = useCallback(() => {
    dispatch(getOpenedTransactions());
  }, [dispatch]);

  useEffect(() => {
    socket.on('TRANSACTION_CREATED', refreshOpenedTransactions);
    socket.on('TRANSACTION_UPDATED', refreshOpenedTransactions);
    socket.on('TRANSACTION_POSTED', refreshOpenedTransactions);
    socket.on('TRANSACTION_CANCELLED', refreshOpenedTransactions);

    return () => {
      socket.off('TRANSACTION_CREATED', refreshOpenedTransactions);
      socket.off('TRANSACTION_UPDATED', refreshOpenedTransactions);
      socket.off('TRANSACTION_POSTED', refreshOpenedTransactions);
      socket.off('TRANSACTION_CANCELLED', refreshOpenedTransactions);
    };
  });

  return <DataTable
    loading={openedTransactionsRedux?.state === LOADING}
    columns={openedTransactionsTableColumns}
    data={openedTransaction}
    onRowClick={(row) => {
      history.push(`${path}/sale/${row.ID}`);
    }}
  />
}

export default OpenedTransactions;
